import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const reports = accountId => ({
  parentNav: 'reports',
  routes: [
    'account_overview_reports',
    'conversation_reports',
    'csat_reports',
    'bot_reports',
    'agent_reports',
    'label_reports',
    'inbox_reports',
    'team_reports',
    'phone_reports',
    'whatsapp_tariff_reports',
    'recording_reports',
    'contact_reports_index',
    'contact_reports_show',
  ],
  menuItems: [
    {
      icon: 'arrow-trending-lines',
      label: 'REPORTS_OVERVIEW',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/overview`),
      toStateName: 'account_overview_reports',
    },
    {
      icon: 'chat',
      label: 'REPORTS_CONVERSATION',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/conversation`),
      toStateName: 'conversation_reports',
    },
    {
      icon: 'emoji',
      label: 'CSAT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/csat`),
      toStateName: 'csat_reports',
    },
    {
      icon: 'bot',
      label: 'REPORTS_BOT',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.RESPONSE_BOT,
      toState: frontendURL(`accounts/${accountId}/reports/bot`),
      toStateName: 'bot_reports',
    },
    {
      icon: 'people',
      label: 'REPORTS_AGENT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/agent`),
      toStateName: 'agent_reports',
    },
    {
      icon: 'tag',
      label: 'REPORTS_LABEL',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/label`),
      toStateName: 'label_reports',
    },
    {
      icon: 'mail-inbox-all',
      label: 'REPORTS_INBOX',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/inboxes`),
      toStateName: 'inbox_reports',
    },
    {
      icon: 'people-team',
      label: 'REPORTS_TEAM',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/teams`),
      toStateName: 'team_reports',
    },
    {
      icon: 'contact-card-group',
      label: 'REPORTS_CONTACT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/contacts_overview`),
      toStateName: 'contact_reports_index',
    },
    // Tarifação WhatsApp oculta por enquanto (rota e tela mantidas)
    // {
    //   icon: 'i-lucide-receipt',
    //   label: 'REPORTS_TARIFF',
    //   hasSubMenu: false,
    //   toState: frontendURL(`accounts/${accountId}/reports/tariff`),
    //   toStateName: 'whatsapp_tariff_reports',
    // },
    {
      icon: 'call',
      label: 'REPORTS_PHONE',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/phone`),
      toStateName: 'phone_reports',
    },
    {
      icon: 'video',
      label: 'REPORTS_RECORDINGS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/recordings`),
      toStateName: 'recording_reports',
    },
  ],
});

export default reports;
